import React, { FC } from "react";
import { Reservation } from "@/types/reservation";
import { formatGuestString } from "@/lib/booking-utils";
import { InfoField } from "@/components/pages/chats/component/ui/InfoField";
import { FoldableContainer } from "@/components/pages/chats/component/booking-info-components/FoldableContainer";

interface GuestsBookingInfoProps {
  booking: Reservation;
}

export const GuestsBookingInfo: FC<GuestsBookingInfoProps> = ({ booking }) => {
  return (
    <FoldableContainer titleNode={"Guest info"}>
      {[
        {
          title: "Phone",
          value: booking.guest.profile.phone,
          copyable: true,
        },
        {
          title: "Email",
          value: booking.guest.profile.email,
          copyable: true,
        },
        {
          title: "Guests",
          value: formatGuestString(booking.additionalGuests),
        },
        {
          title: "Country",
          value: booking.guest.profile.language,
        },
      ].map(({ title, value, copyable }) => (
        <InfoField
          key={title}
          copyable={copyable}
          title={title}
          value={value ?? ""}
        />
      ))}
    </FoldableContainer>
  );
};
